<div class="pincode-dialog-container">
    <button mat-dialog-close mat-icon-button class="close-button" (click)="closeAll()">
        <mat-icon>close</mat-icon>
    </button>

    <form [formGroup]="firstFormGroup" autocomplete="off" class="pincode-form">
        <div class="form-content">
            <mat-form-field appearance="outline" fxFlex class="pincode-input-field">
                <mat-label>Zip code</mat-label>
                <input numbersOnly [autocomplete]="'off'" trim="blur" matInput formControlName="pincode">
            </mat-form-field>
            
            <p class="pincode-description">
                Please enter your pin code. If pin code is not listed please enter nearby pincode
            </p>
        </div>

        <div class="form-actions" fxLayout="row" fxLayoutAlign="end center">
            <button (click)="savePincodePricing()" mat-raised-button class="submit-button">
                SUBMIT
            </button>
        </div>
    </form>
</div>